class RegisterLoginController {
    /*@ngInject*/
    constructor(FetchForgottenPasswordFormService) {
        this.FetchForgottenPasswordFormService = FetchForgottenPasswordFormService;
        this.requestPending = false;
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }

    passwordForgotten() {
        this.FetchForgottenPasswordFormService.fetchForgottenPasswordForm();
    }
}

export default RegisterLoginController;
